export let modules = {
  C: {
    key: 'C',
    label: 'Przejazdy',
    description:
      'Moduł pozwala na prowadzenie szczegółowej ewidencji przebiegu pojazdu, umożliwiającą odliczenie 100% VATu dla firmowych samochodów osobowych używanych wyłącznie do celów firmowych.\n' +
      '<br>Służy także do rozliczania m.in. przebiegu pojazdów nie ujętych w ewidencji środków trwałych, a wykorzystywanych do prowadzenia działalności gospodarczej (np. prywatne samochody pracowników rozliczane wg tzw. kilometrówki). Umożliwia gromadzenie danych dla dowolnej ilości pojazdów i za dowolny okres. ',
  },
  D: {
    key: 'D',
    label: 'Delegacje',
    description:
      'Moduł rozliczenia delegacji umożliwia:<ol>' +
      '<li>sporządzanie poleceń wyjazdu i ich wydruk,</li>' +
      '<li>rozliczanie delegacji krajowych,</li>' +
      '<li>rozliczanie delegacji zagranicznych,</li>' +
      '<li>rozliczanie zaliczek,</li>' +
      '<li>rozliczanie przejazdów, noclegów i innych wydatków.</li></ol>',
  },
  F: {
    key: 'F',
    label: 'Fakturowanie',
    description:
      'Wystawienie i tworzenie dokumentów sprzedażowych: faktury Zaliczkowej, Zaliczkowej końcowej, RR, MP, Marża, Pro forma, Mechanizm Podzielonej Płatności), faktur masowych, dokumentów korygujących, rachunków, WZ, paragonów, także faktury dla nie-vatowców lub do paragonów oraz lista towarów i usług (cennik) z dużym polem na opis.\n' +
      '</br>Wystawianie faktur w języku <b>angielskim</b> i <b>niemieckim</b>! Automatyczne pobieranie kursów walut dla cen w walutach obcych oraz nadruk na fakturze dwóch kont bankowych.',
  },
  M: {
    key: 'M',
    label: 'miniMagazyn',
    description:
      'Obsługa obrotu magazynowego oraz przygotowania dokumentu do wystawienia faktur lub rachunków. Moduł ten jest przeznaczony dla małych i średnich firm oraz osób prowadzących działalność gospodarczą związaną z obrotem magazynowym. \n' +
      '<br>Polecany zwłaszcza dla firm, które obracają towarem zgromadzonym w jednym magazynie, a ich asortyment nie przekracza 5000 pozycji. \n' +
      '<br>W wersjach programu nieposiadających modułu "Magazyn" znajduje się jego wersja prezentacyjna, która jest dostępna w zakładce Fakturowanie. Umożliwia ona wykonanie 10 przyjęć oraz 10 wydań magazynowych. Uwaga! Po zakupie modułu "Magazyn" dotychczasowy moduł "Fakturowanie" pozostaje bez zmian.',
  },
  P: {
    key: 'P',
    label: 'Płace i ZUS',
    description:
      '<ol>' +
      '<li>wyliczyć wynagrodzenia na podstawie różnych umów (z tytułu umów o pracę, umów zleceń, o dzieło i ryczałtowych, kontraktów menadżerskich, działalności artystycznej, praw autorskich i in.), z uwzględnieniem zwolnienia od opodatkowania osób poniżej 26 r.ż.</li>' +
      '<li>obliczyć wynagrodzenia za czas choroby i inne świadczenia (np.rehabilitacyjne, zasiłek opiekuńczy),</li>' +
      '<li>automatycznie księgować wynagrodzenia,</li>' +
      '<li>wystawiać deklarację ZUS (DRA, RMUA, RCA, RSA, RZA, RPA) i eksportować dane do programu Płatnik,</li>' +
      '<li>drukować druki ZUS (ZUS-3 i ZUS-3A, ZUS-7, ZUS Z-17),</li>' +
      '<li>drukować dokumenty – wzory: umów o pracę, o dzieło i zlecenie; rachunków do umowy o dzieło i zlecenie; zaświadczeń o zatrudnieniu; zaświadczeń o zarobkach; świadectw pracy; wypowiedzeń,</li>' +
      '<li>tworzyć deklaracje PIT-11, -4R, -8AR, IFT1/1R,</li>' +
      '<li>tworzyć listy płac i karty wynagrodzeń,</li>' +
      '<li>prowadzić kart pracy</li></ol>',
  },
  T: {
    key: 'T',
    label: 'Środki trwałe i wyposażenie',
    description:
      'Umożliwia prowadzenie ewidencji: <ol><li>wyposażenia</li><li>środków trwałych oraz wartości niematerialnych i prawnych. </li></ol>' +
      'Program wylicza miesięczne i roczne odpisy amortyzacyjne oraz prognozuje termin zakończenia amortyzacji, pozostałą kwotę do umorzenia w ujęciu rocznym i całym przebiegu amortyzacji ilość rat. Odpisy amortyzacyjne można obliczać za pomocą amortyzacji liniowej lub degresywnej, albo metodą jednorazową. Umożliwia również ulepszanie, zmniejszanie wartości środka trwałego oraz wprowadzanie przerw w trwaniu amortyzacji, a także wprowadzania limitów.' +
      '<br>Ponadto w programie znajdują się dokumenty OT, LT oraz korekty roczne.',
  },
  V: {
    key: 'V',
    label: 'Podatek VAT',
    description:
      'Ten moduł umożliwia prowadzenie rejestrów VAT sprzedaży oraz zakupu towarów handlowych, środków trwałych, usług i innych. Na podstawie rejestrów sporządzonych jedną z dostępnych metod: memoriałową miesięczną, memoriałowo kwartalną i kasową, z uwzględnieniem obrotów z kilku źródeł, program:\n' +
      '<ol><li>tworzy plik JPK_V7M/7K i umożliwia jego elektroniczną wysyłkę</li>' +
      '<li>tworzy i umożliwia wysyłkę e-deklaracji VAT-UE i VAT UEK</li>' +
      '<li>tworzy deklaracje VAT-8, 9M, 10, 11, 12 z możliwością ich wydruku</li>' +
      '<li>sporządza przelewy do urzędu skarbowego</li>' +
      '<li>kontroluje dla wykonywania korekt VAT po 90 dniach od przeterminowania (niezapłacenia) i tworzy w/w korekt wraz z ich obsługą masową.</li>' +
      '</ol>',
  },
  R: {
    key: 'R',
    label: 'Ryczałt ewidencjonowany',
    description:
      'Umożliwia rozliczenie podatku dochodowego za pomocą ryczałtu od przychodów ewidencjonowanych, w tym sporządzenie i wydruk PIT-28 wraz załącznikami.',
  },
  L: {
    key: 'L',
    label: 'VAT OSS',
    description:
      'Dzięki modułowi VAT OSS:  \n' +
      '<ol>\n' +
      '<li>Poprowadzisz miesięczne rejestry VAT w zakresie rozliczania podatku VAT w punkcie \n' +
      'kompleksowej obsługi OSS w procedurze unijnej w zakresie:  \n' +
      '<ul>\n' +
      '<li>usług świadczonych na rzecz konsumentów w państwach członkowskich, w których usługodawca nie ma siedziby (B2C);</li>\n' +
      '<li>wewnątrzwspólnotowej sprzedaży towarów na odległość;</li>\n' +
      '<li>dostaw krajowych ułatwianych przez operatorów interfejsów elektronicznych, uznanych za dostawców;</li>\n' +
      '</ul>\n' +
      '</li>\n' +
      '<li>Sporządzisz kwartalną deklaracje podatkową VIU-D i wyślesz ją poprzez system e-Deklaracji;</li>\n' +
      '<li>Zaksięgujesz z tego tytułu  przychód do PKPiR;</li>\n' +
      '<li>Przeliczysz kwoty transakcji na Euro wg kursu EBC wystawione w innych walutach, np. w PLN lub tej obowiązującej w danym kraju np. w Chorwacji - Kuny i wg kursu NBP do podatku dochodowego.</li>\n' +
      '</ol>',
  },
};

export let m_skp_F = ['C', 'D', 'F', 'M', 'T', 'V', 'L'];
export let m_skp_B = ['C', 'D', 'M', 'T', 'R', 'L'];
export let m_sam = ['M', 'T', 'L'];
export let m_all = [
  'C',
  'D',
  'F',
  'M',
  'P',
  'T',
  'R',
  'V',
  'L',
  'P1',
  'P2',
  'P3',
];
export let m_skp_O = ['M'];
export let m_skp_T = ['C', 'D', 'M', 'P', 'R', 'T', 'V', 'L'];
